module.exports = __webpack_public_path__ + "img/heart-crack.17c7bce6.svg";